import getIn from '@alexaivars/get-in';
import { STATES } from './constants';

const createResourceActionMatchers = (
  baseActionsCreate,
  baseActionsMerge,
  baseActionsRemove,
  baseActionsDestroy,
) => ({
  CREATE: []
    .concat(baseActionsCreate)
    .map(action => `${action}_${STATES.SUCCESS}`),
  MERGE: []
    .concat(baseActionsMerge)
    .map(action => `${action}_${STATES.SUCCESS}`),
  REMOVE: []
    .concat(baseActionsRemove)
    .map(action => `${action}_${STATES.SUCCESS}`),
  DESTROY: [].concat(baseActionsDestroy).map(action => action),
});

// CREATE - create new list
// MERGE - returns list with old and new items
// REMOVE - remove item from list
// DESTROY - delete complete list

const selectBodyData = action => getIn(action, ['payload', 'body', 'data'], []);

const createResourceListReducer = (
  baseActionsCreate,
  baseActionsMerge,
  baseActionsRemove,
  baseActionsDestroy,
  actionPayloadSelector,
) => {
  const { CREATE, MERGE, REMOVE, DESTROY } = createResourceActionMatchers(
    baseActionsCreate,
    baseActionsMerge,
    baseActionsRemove,
    baseActionsDestroy,
  );

  const getData = actionPayloadSelector || selectBodyData;

  return (state = [], action = {}) => {
    const data = [].concat(getData(action));
    if (CREATE.includes(action.type)) {
      return data.map(item => item.id);
    } else if (MERGE.includes(action.type)) {
      const ids = data.map(item => item.id);
      return state
        .filter(id => !ids.includes(id))
        .concat(data.map(item => item.id));
    } else if (REMOVE.includes(action.type)) {
      const ids = data.map(item => item.id);
      return state.filter(id => !ids.includes(id));
    } else if (DESTROY.includes(action.type)) {
      return [];
    } else {
      return state;
    }
  };
};

export default createResourceListReducer;
